module.exports = __webpack_public_path__ + "img/school-ecommerce250.806c4d0a.png";